module.exports = __webpack_public_path__ + "static/img/3.37049f16.png";